<template>
  <transition name="menu">
    <nav id="menu" class="menu-area" v-if="showMenu">
      <ul>
        <li>
          <div class="perfil">
            <img :src="user.cover" />
            <p>{{ user.name }}</p>
            <span class="detail">{{ user.email }}</span>
          </div>
        </li>
        <li>
          <router-link :to="{ name: 'auth.dashboard' }">Inicial</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'app.about' }">Sobre</router-link>
        </li>
        <li class="end">
          <a class="button" href="#logout" @click.prevent="logout()">Sair</a>
        </li>
      </ul>
      <a href="#" @click.prevent="hideMenu()">
        <img :src="require('@/assets/images/remove.svg')" />
      </a>
    </nav>
  </transition>
</template>

<script>
export default {
  name: 'MenuArea',
  computed: {
    user() {
      return this.$store.state.user;
    },
    showMenu() {
      return this.$store.state.menu;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    hideMenu() {
      this.$store.commit('menuHide');
    },
  },
};

</script>

<style scoped>
  .menu-area {
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 8000;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    overflow: hidden;
    background-image: linear-gradient(90deg, rgba(0,0,0,1), var(--color-secondary-opacity));
  }
  .menu-area ul{
    width: calc(100% - 60px);
    background-color: var(--color-dashboard);
    overflow-x: hidden;
    overflow-y: auto;
  }
  .menu-area ul li{
    width: 100%;
    min-height: 80px;
    border-bottom: 1px solid white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
  }
  .menu-area ul li.end{
    border-bottom: none;
  }
  .menu-area ul li a{
    color: var(--color-secondary-dark);
  }
  .menu-area ul li.end{
    margin-bottom: 100px;
  }
  .menu-area ul li.end a{
    color: white;
    flex: none;
    padding: 10px 40px;
  }
  .menu-area a{
    flex: 1;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .menu-area a img{
    width: 40px;
  }
  .perfil{
    padding: 30px;
  }
  .perfil img{
    width: 80px;
    height: 80px;
    border-radius: 40px;
    object-fit: cover;
    margin-bottom: 15px;
  }
  .perfil p{
    background-color: var(--color-secondary-dark);
    padding: 10px 30px;
    border-radius: 20px;
    color: white;
  }
  .perfil .detail{
    display: inline-block;
    margin-top: 10px;
    font-size: .8rem;
    color: var(--color-primary-dark);
  }

  @media only screen and (min-width: 600px) and (max-width: 900px) {
    .menu-area ul{
      max-width: 600px;
    }
  }

  @media only screen and (min-width: 900px) {
    .menu-area ul{
      max-width: 900px;
    }
  }
</style>
